import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function resolveActiveCompanyId(user) {
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  if (roles.includes('administrator')) {
    return (
      user?.activeCompany?.id ??
      user?.activeCompany?.company_id ??
      user?.activeCompany?.companyId ??
      ''
    );
  }
  return (
    user?.myCompany?.id ??
    user?.myCompany?.company_id ??
    user?.myCompany?.companyId ??
    user?.company?.id ??
    ''
  );
}

export default function QuickCreateDrawer({ open, onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const hasActiveCompany = useMemo(
    () => Boolean(String(resolveActiveCompanyId(user) || '').trim()),
    [user],
  );

  if (!open) return null;

  const go = (path, create) => {
    onClose();
    navigate(path, { state: create ? { quickCreate: true } : undefined });
  };

  return (
    <div
      className="webhooks-drawerOverlay"
      onMouseDown={(event) => event.target === event.currentTarget && onClose()}
    >
      <aside className="webhooks-drawer">
        <div className="webhooks-drawerHeader">
          <div>
            <p className="eyebrow">{t('quickCreate')}</p>
            <h2>{t('quickCreateTitle')}</h2>
          </div>
          <button className="topbar-icon-button" type="button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="webhooks-quickCreate">
          <button type="button" onClick={() => go('/outgoing_webhooks', true)}>
            {t('quickCreateWebhook')}
            <small>{t('quickCreateWebhookHint')}</small>
          </button>
          <button type="button" onClick={() => go('/api_keys', true)}>
            {t('quickCreateApiKey')}
            <small>{t('quickCreateApiKeyHint')}</small>
          </button>
          <button type="button" onClick={() => go('/integrations', true)}>
            {t('quickCreateIntegration')}
            <small>{t('quickCreateIntegrationHint')}</small>
          </button>
          {hasActiveCompany && (
            <button type="button" onClick={() => go('/calculations', true)}>
              {t('quickCreateShipment')}
              <small>{t('quickCreateShipmentHint')}</small>
            </button>
          )}
        </div>
      </aside>
    </div>
  );
}
